// A user-type promotion is single-use: core-api removes a user once their voucher
// is consumed. The form PUTs the whole entity, so a stale form would put a consumed
// user back. The user list is therefore sent as a delta against what the form loaded.

export function toUserIris(users) {
    if (!Array.isArray(users)) {
        return []
    }

    return users
        .map((user) => (user && typeof user === 'object' ? user['@id'] : user))
        .filter((iri) => typeof iri === 'string' && iri !== '')
}

// final = (serverUsers − (loadedUsers − formUsers)) ∪ (formUsers − loadedUsers)
// The server order is kept, additions are appended, no duplicates.
export function mergePromotionUsers(serverUsers, loadedUsers, formUsers) {
    const server = toUserIris(serverUsers)
    const loaded = toUserIris(loadedUsers)
    const form = toUserIris(formUsers)

    const removed = loaded.filter((iri) => !form.includes(iri))
    const added = form.filter((iri) => !loaded.includes(iri))

    const result = []
    server
        .filter((iri) => !removed.includes(iri))
        .concat(added)
        .forEach((iri) => {
            if (!result.includes(iri)) {
                result.push(iri)
            }
        })

    return result
}
